export { default as InfoView } from './InfoView';
